export const datepicker = {
  date: {
    padding: '0',
  },
}
